/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkReportListResponse {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkReportListResponse.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkReportListResponse>): WellArchitectedFrameworkReportListResponse {
        let obj = Object.assign(new WellArchitectedFrameworkReportListResponse(), model);
        WellArchitectedFrameworkReportListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkReportListResponse>): WellArchitectedFrameworkReportListResponse {
        if (!model) return null;
        return WellArchitectedFrameworkReportListResponse.newInstance(<WellArchitectedFrameworkReportListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkReportListResponse) {
        if (!obj) return;

        models.WellArchitectedFrameworkReportListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkReportListResponse): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkReportListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
